type ImageQuality = 'high' | 'low' | undefined;
export interface CardHeaderEditState {
  coverEditorVersion?: string | undefined;
  coverPhotoPreviewUrl?: string | undefined;
  coverQuality?: ImageQuality | undefined;
  logoEditorVersion?: string | undefined;
  logoImagePreviewUrl?: string | undefined;
  logoQuality?: ImageQuality | undefined;
  picturePreview?: 'cover' | 'profile' | 'logo' | undefined;
  appliedPresetId?: string | undefined;
  profileEditorVersion?: string | undefined;
  profilePicturePreviewUrl?: string | undefined;
  profileQuality?: ImageQuality | undefined;
}
export type CardHeaderEditReducerAction =
  | { type: 'RESET' }
  | { type: 'SET_EDITOR_VERSION'; cover?: string; profile?: string; logo?: string }
  | { type: 'SET_PICTURE_PREVIEW'; value: 'cover' | 'profile' | 'logo' | undefined }
  | { type: 'SET_PRESET_ID'; value: string | undefined }
  | { type: 'SET_PROFILE_PICTURE_PREVIEW_URL'; value: string; quality?: ImageQuality | undefined }
  | { type: 'SET_LOGO_IMAGE_PREVIEW_URL'; value: string; quality?: ImageQuality | undefined }
  | { type: 'SET_COVER_PHOTO_PREVIEW_URL'; value: string; quality?: ImageQuality | undefined }
  | {
      type: 'SET_QUALITY';
      logo?: ImageQuality | undefined;
      profile?: ImageQuality | undefined;
      cover?: ImageQuality | undefined;
    };

export const reducer = (
  state: CardHeaderEditState,
  action: CardHeaderEditReducerAction,
): CardHeaderEditState => {
  switch (action.type) {
    case 'RESET':
      return {};
    case 'SET_PRESET_ID':
      return {
        ...state,
        appliedPresetId: action.value,
      };
    case 'SET_EDITOR_VERSION':
      return {
        ...state,
        coverEditorVersion: action.cover || state.coverEditorVersion,
        profileEditorVersion: action.profile || state.profileEditorVersion,
        logoEditorVersion: action.logo || state.logoEditorVersion,
      };
    case 'SET_PICTURE_PREVIEW': {
      return {
        ...state,
        picturePreview: action.value,
      };
    }
    case 'SET_COVER_PHOTO_PREVIEW_URL':
      return { ...state, coverPhotoPreviewUrl: action.value, coverQuality: action.quality };
    case 'SET_LOGO_IMAGE_PREVIEW_URL':
      return { ...state, logoImagePreviewUrl: action.value, logoQuality: action.quality };
    case 'SET_PROFILE_PICTURE_PREVIEW_URL':
      return { ...state, profilePicturePreviewUrl: action.value, profileQuality: action.quality };
    case 'SET_QUALITY':
      return {
        ...state,
        coverQuality: action.cover,
        logoQuality: action.logo,
        profileQuality: action.profile,
      };
  }
  return state;
};
